import SearchBar from './SearchBarContainer'

export default SearchBar